import $ from "jquery";

const init = () => {
  removeElement();
};

const removeElement = () => {
  if (window.innerWidth > 768) {
    $(".booking-form-mobile").remove();
  }
};

try {
  init();
} catch (error) {
  console.log(error);
}
